import { Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-image-board',
  templateUrl: './image-board.component.html',
  styleUrls: ['./image-board.component.sass'],
})
export class ImageBoardComponent implements OnInit {
  @ViewChild('zoomTemplate') zoomTemplate!: TemplateRef<any>;
  zoomDialogRef!: MatDialogRef<any>;

  images: string[] = [];
  selectedImage = '';
  selectedIndex = 0;
  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ImageBoardComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      idTrade: string;
      images: string[];
    }
  ) {}

  ngOnInit(): void {
    this.images = this.data?.images || [];
  }

  close(): void {
    this.dialogRef.close();
  }

  zoomDialog(image: string,  index: number): void {
    this.selectedImage = image;
    this.selectedIndex = index;

    this.zoomDialogRef = this.dialog.open(this.zoomTemplate, {
      panelClass: 'no-padding-dialog',
      width: '50%',
      height: '70%',
      autoFocus: false,
    });
  }

  closeZoom(): void {
    this.zoomDialogRef?.close();
  }
}
